
    import I18n from 'i18nObj';
    
      import 'translations/pseudonyms_mobile_login';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('pseudonyms_mobile_login');
  